import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';

export function* toggleHDStreamSaga() {
  yield call(RTCClient.publishingFeed.toggleSimulcastHDLayer);
}
